import conf from '../conf.js';

/**
 * @param {Object} user univers du user
 * @param {Array} universes univers du user
 * @returns {Object}
 */
export function getUserMainUniverse(user, universes = []) {
  if (user.mainUniverse) {
    const filteredUniverses = universes.filter((universe) => universe.id === user.mainUniverse);

    return filteredUniverses.length ? filteredUniverses[0] : null;
  }

  return null;
}

export function getLandingAreaForUser(user) {
  return (user !== null && user.account_type === conf.accountTypes.freelance) ? 'freelance' : 'company';
}

export function getLandingRouteNameForUser(user = null, universes = []) {
  if (user === null) {
    return false;
  }

  if(isUserFreelance(user)) {
    if(!isUserComplete(user)){
      return 'homepage'
    }
    return 'freelance-dashboard'
  }

  let route = 'landing-' + getLandingAreaForUser(user);

  if (universes.length !== 0) {
    return universes.reduce((acc, universe) => {
      if (universe.active && universe.id === user.mainUniverse) {
        acc = route += ('-' + universe.code);
      }
      return acc;
    }, false);
  } else {
    route += '-connected';
  }

  return route;
}

/**
 * Return true if the user is admin in the current universe, false otherwise
 *
 * @param {Object} user
 * @param {Object} currentUniverse currentUniverse
 * @returns {boolean}
 */
export function isAdmin(user = null, currentUniverse = null) {
  if (user === null) {
    return false;
  }

  if (currentUniverse === null) {
    return user.isAdmin;
  }

  return user.isAdmin || ((user.isBusinessManager || user.isSupport) && user.universes.includes(currentUniverse.id));
}

/**
 * @param {Object} user
 * @returns {boolean}
 */
export function isConnected(user) {
  return !!user?.id
}

/**
 * @param {Object} user
 * @returns {boolean}
 */
export function isUserDo(user) {
  if (!user) {
    return false;
  }

  if (!isConnected(user)) {
    return false;
  }

  return user.account_type === conf.accountTypes.do;
}

/**
 * @param {Object} user
 * @returns {boolean}
 */
export function isUserFreelance(user) {
  if (!user) {
    return false;
  }

  if (!isConnected(user)) {
    return false;
  }

  return user.account_type === conf.accountTypes.freelance;
}

export function isUserComplete(user) {
  if (!user) {
    return false;
  }

  if (!isConnected(user)) {
    return false;
  }

  return user?.complete
}


// Agent == Business Manager
export const isUserAgent = (user) => {
  if (!user) {
    return false;
  }

  if (!isConnected(user)) {
    return false;
  }

  return user.isBusinessManager
}

export function prepareUserBeforeSubmit(user) {
  const userCity = user.city ? user.city : {}
  const workCities = user.work_cities.map(city => {return city.id})
  const work_cities = user.work_cities

  if(userCity.id) {
    if(workCities && !workCities.includes(userCity.id)) {
      workCities.push(userCity.id)
    }
    if (!(user.work_cities.find((city) => (city.id === userCity.id)))) {
      work_cities.push(userCity)
    }
  }

  return {
    ...user,
    workCities: workCities,
    work_cities: work_cities,
  }
}
